const TRANSLATION_KEY_PATTERN = /^[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)+$/;

const isTranslationKey = (text?: string): text is string =>
  typeof text === "string" && TRANSLATION_KEY_PATTERN.test(text.trim());

export default isTranslationKey;
